// extracted by mini-css-extract-plugin
export default {"site-layout-content":"onboarding_site-layout-content__0d29N","steps-content":"onboarding_steps-content__Mj0or"};